import { lazy } from "react";
import { ListChecks } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

/**
 * Work — the ranked queues. Roles mirror the backend prioritisation guard.
 */
export const workFeature: FeatureDescriptor = {
  id: "prioritisation",
  flag: "prioritisation",
  path: "/work",
  group: "operate",
  navKey: "nav.work",
  icon: ListChecks,
  element: lazy(() => import("./WorkPage")),
  roles: ["admin", "manager"],
  scope: { locality: true, days: true },
};
